import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getItemSource } from '../../../api/items';
import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const fetchItemSource = createAsyncThunk(
  'items/fetchItemSource',
  async (data, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getItemSource(data, {
        cancelToken: source.token,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.status);
    }
  },
);

export const fetchItemSourceExtraReducers = builder => {
  builder
    .addCase(fetchItemSource.pending, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

      checkAndSetLoadingWithId(state.items.source.request, action, itemCIDKey);
    })
    .addCase(fetchItemSource.fulfilled, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

      onMatchedRequest(state.items.source.request[itemCIDKey], action, () => {
        state.items.source.byId[itemCIDKey] = action.payload;
      });
    })
    .addCase(fetchItemSource.rejected, (state, action) => {
      handleRequestRejection(
        state.items.source.request[generateItemCIDKey(action.meta.arg.path)],
        action,
      );
    });
};
